<template>
  <div class="thres">
    <!-- 头部 -->
    <div class="thretop">
      <div class="thretop_title fs32">{{ data.name }}</div>
      <div
        class="thretop_msg fs22"
        :class="
          data.value >= data.lowerLimit && data.value <= data.uperLimit
            ? 'lv'
            : 'ho'
        "
      >
        {{ $t("live.waring_text") }}：{{ data.lowerLimit }}-{{ data.uperLimit
        }}{{ data.unit }}
      </div>
      <div class="thretop_close" @click="handleCloseThres">
        <img src="src/assets/images/close.png" />
      </div>
    </div>
    <div class="threform fs28">
      <!-- <div class="radio fs28">
        <van-radio-group v-model="type" direction="horizontal">
          <van-radio name="1">{{ $t("live.settime_start_stop") }}</van-radio>
          <van-radio name="2">{{ $t("live.relation_start_stop") }}</van-radio>
        </van-radio-group>
      </div> -->
      <div class="timing">
        <div>
          <van-form @submit="onSubmit">
            <van-field
              v-model="data.portName"
              label="阀门名称"
              maxlength="8"
              name="portName"
              :rules="[{ required: true, message: '阀门名称不能为空' }]"
            />

            <div class="btns">
              <van-button class="threbtn reset" @click="handleReset">
                重置
              </van-button>
              <van-button
                class="threbtn fs28 orangeToYellow"
                native-type="submit"
              >
                {{ $t("live.thre_btn") }}
              </van-button>
            </div>
          </van-form>
        </div>

        <!-- <div class="tform" v-show="type === '2'">
          <div class="txt fs28">{{ $t("live.relation") }}</div>
          <div class="value">
            <input v-model="relation" :placeholder="$t('live.msg_cgq')" disabled>
            <div class="mask" @click="handleClickTime(RELATION)"></div>
          </div>
        </div>
        <div class="tform">
          <div class="txt fs28">{{ $t("live.open_time") }}</div>
          <div class="value">
            <input v-model="sTime" :placeholder="$t('live.msg_open_time')" disabled>
            <div class="mask" @click="handleClickTime(STIME)"></div>
          </div>
        </div>
        <div class="tform fs28">
          <div class="txt">{{ $t("live.stop_time") }}</div>
          <div class="value">
            <input v-model="eTime" :placeholder="$t('live.msg_stop_time')" disabled>
            <div class="mask" @click="handleClickTime(ETIME)"></div>
          </div>
        </div> -->
      </div>
    </div>
    <!-- 时间popup -->
    <van-popup
      v-model="showTimePopup"
      position="bottom"
      :style="{ width: '100%', height: '6.8rem' }"
    >
      <van-datetime-picker
        v-model="currentDate"
        type="datetime"
        :min-date="minDate"
        :max-date="maxDate"
        @confirm="doConfirm"
        @cancel="doCancel"
        :title="$t('export.time_title')"
        :confirm-button-text="$t('member.login_out_ok')"
        :cancel-button-text="$t('member.login_out_cancel')"
      />
    </van-popup>
    <!-- 传感器popup -->
    <van-popup
      v-model="showRelationPopup"
      position="bottom"
      :style="{ width: '100%', height: '6.8rem' }"
    >
      <van-picker
        title="选择传感器"
        show-toolbar
        :columns="columns"
        @confirm="onConfirm"
        @cancel="handleCloseThres"
      />
    </van-popup>
  </div>
</template>

<script>
export default {
  data() {
    return {
      no: localStorage.getItem("no") ? localStorage.getItem("no") : "", // 记录的设备号
      RELATION: Symbol("ralation"), // 用symbol 解决魔术字符串的耦合性
      STIME: Symbol("sTime"),
      ETIME: Symbol("eTime"),
      currentDate: new Date(),
      minDate: new Date(2020, 0, 1),
      maxDate: new Date(2025, 10, 1),
      showRelationPopup: false,
      showTimePopup: false,
      type: "1",
      popupClickType: "",
      sTime: "",
      eTime: "",
      relation: "",
      data: {},
      columns: [
        "传感器1",
        "传感器2",
        "传感器3",
        "传感器4",
        "传感器5",
        "传感器6",
        "传感器7",
        "传感器8"
      ]
    };
  },

  created() {
    const data = JSON.parse(sessionStorage.getItem("liveSettingData"));
    this.data = { ...data };
  },

  methods: {
    tip(key) {
      this.$toast(this.$t(`live.${key}`));
    },

    // 确认修改
    handleSetHold() {
      const { no, sTime, eTime, relation, type } = this;
      if (type === "2") {
        if (!relation) {
          return this.tip("msg_cgq");
        }
      }

      if (!sTime) {
        return this.tip("msg_open_time");
      }

      if (!eTime) {
        return this.tip("msg_stop_time");
      }

      if (sTime > eTime) {
        return this.tip("msg_open_stop");
      }

      // 提交
    },

    async onSubmit(values) {
      console.log("submit", values);

      await this.$api
        .setValavePortName({
          eqValveId: this.data.id,
          name: values.portName
        })
        .then(res => {
          if (res.errcode === 0) {
            this.$toast.success({
              mask: true,
              message: "修改成功"
            });

            setTimeout(() => {
              this.$router.back();
            }, 1500);
          } else {
            this.$toast.fail(res.errmsg || "修改失败");
          }
        });
    },

    handleReset() {
      const data = JSON.parse(sessionStorage.getItem("liveSettingData"));
      this.data = { ...data };
    },

    // 点击时间
    handleClickTime(type) {
      this.popupClickType = type;
      switch (type) {
        case this.RELATION:
          // 弹出关联传感器
          this.showRelationPopup = true;
          break;
        case this.STIME:
          this.showTimePopup = true;
          break;
        case this.ETIME:
          this.showTimePopup = true;
          break;
        default:
          break;
      }
    },

    // 确认时间
    doConfirm(v) {
      const t = this.$setime(v, 3);
      if (this.popupClickType === this.STIME) {
        this.sTime = t;
      }
      if (this.popupClickType === this.ETIME) {
        this.eTime = t;
      }
      this.doCancel();
    },

    doCancel() {
      this.showRelationPopup = false;
      this.showTimePopup = false;
    },

    // select
    onConfirm(value, index) {
      this.relation = this.columns[index];
      this.handleCloseThres();
    },

    // 关闭
    handleCloseThres() {
      this.showPopup = false;
      this.showRelationPopup = false;
    }
  }
};
</script>

<style lang="scss" scoped>
/*上滑层*/
.thretop {
  position: relative;
  border-bottom: 1px solid #f4f4f4;
  padding: 0.2rem;
  background: linear-gradient(
    90deg,
    rgba(53, 105, 233, 0.9) 0%,
    rgba(24, 76, 204, 1) 100%
  ) !important;
  color: #ffffff;
}

.thretop .thretop_msg {
  color: #ffffff;
  padding-left: 0.3rem;
  background: url(../../../assets/images/lv.png) 0 0.15rem no-repeat;
  background-size: 0.22rem 0.22rem;
  padding-top: 0.1rem;
}

.thretop .thretop_msg.lv {
  background: url(../../../assets/images/lv.png) 0 0.15rem no-repeat;
  background-size: 0.22rem 0.22rem;
}

.thretop .thretop_msg.ho {
  background: url(../../../assets/images/red.png) 0 0.15rem no-repeat;
  background-size: 0.22rem 0.22rem;
}

.thretop .thretop_close {
  position: absolute;
  right: 0.2rem;
  top: 0.2rem;
}

.thretop .thretop_close img {
  width: 0.29rem;
  height: 0.29rem;
  vertical-align: text-top;
}

.threform {
  width: 6.7rem;
  margin: 0 auto;
  padding-top: 0.1rem;

  .radio {
    padding: 0.2rem 0;
  }
}

.threform .tform {
  display: flex;
  overflow: hidden;
  line-height: 1rem;
  background: #f4f4f4;
  border-radius: 0.1rem;
  margin-top: 0.2rem;

  .value {
    position: relative;

    .mask {
      position: absolute;
      top: 0;
      right: 0;
      bottom: 0;
      left: 0;
      margin: auto;
    }
  }
}

.threform .tform .txt {
  float: left;
  width: 2.06rem;
  text-align: center;
}

.threform .tform input {
  float: left;
  width: 4.64rem;
  border: none;
  background: none;
  font-size: 0.28rem;
}

.tis {
  font-size: 0.22rem;
  color: #999;
  text-align: center;
  padding: 0.25rem 0;
}

.threbtn {
  width: 6.7rem;
  margin: 0 auto;
  height: 1rem;
  line-height: 1rem;
  border-radius: 0.1rem;
  text-align: center;
  color: rgb(186, 120, 120);
  margin-top: 0.1rem;
}

/*上滑层 end*/

.timing {
  margin-top: 20px;
  height: 90px;

  .btns {
    display: flex;
    justify-content: space-between;
    align-items: center;

    button {
      flex: 1;

      &:last-child {
        margin-left: 10px;
        color: #ffffff;
      }
    }

    .reset {
      color: inherit;
    }
  }
}
</style>
